import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-grow text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "All Available Projects", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Connect "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-blue-500",
    href: "https://cms2.engagelab.uiocloud.no",
    target: "none"
  }, "Squidex"),
  /*#__PURE__*/_createTextVNode(" projects to interventions here ")
], -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Add")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonitorProjectItem = _resolveComponent("MonitorProjectItem")!
  const _component_SlButton = _resolveComponent("SlButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createVNode(_component_MonitorProjectItem, {
              edit: true,
              project: p,
              class: "my-2"
            }, null, 8 /* PROPS */, ["project"])
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createVNode(_component_SlButton, {
          class: "my-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addProject()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}